import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { LANG_EN, LANG_EN_US } from 'language/langutil';
import svcs from 'services';
import { useDisplayPopupItem } from 'store/reducers/useDisplayPopup';
import { useZstdInfo } from 'zstd/useZstdInfo';
import { AppInit } from './layout/AppInit';

const SearchBoxPopup2 = React.lazy(() => import('search2/SearchBoxPopup2'));
const CookiePopup = React.lazy(() => import('cookie/CookiePopup'));

// createBrowserRouter + RouterProvider 패턴의 root layout.
// Router 경계 안에서 살아있어야 하는 init/popup/Outlet을 모두 담당한다.
export const RootLayout = () => {
  const { showSearchBoxPopup, setShowSearchBoxPopup } = useZstdInfo();
  const { popupEnabled } = useDisplayPopupItem();
  const lang = svcs.svcLang.lang();

  return (
    <>
      <AppInit />
      {showSearchBoxPopup && (
        <Suspense fallback={<div></div>}>
          <SearchBoxPopup2 isPopup={true} setInput={true} defaultFocusedInput nonDisplayRelated={true} />
        </Suspense>
      )}
      {showSearchBoxPopup && (
        <Overlay
          aria-label={'search-popup-overlay'}
          onClick={() => {
            setShowSearchBoxPopup(false);
          }}
        />
      )}
      {popupEnabled('cookie') && [LANG_EN, LANG_EN_US].includes(lang) && (
        <Suspense fallback={null}>
          <CookiePopup />
        </Suspense>
      )}
      <Outlet />
    </>
  );
};

const Overlay = styled.div`
  position: fixed;
  left: 0;
  top: 60px;
  width: 100%;
  height: calc(100vh - 60px);
  background-color: rgba(0, 0, 0, 0.5);

  z-index: 10;
  @media screen and (max-width: 764px) {
    top: 53px !important;
    height: calc(100vh - 53px) !important;
  }
`;
